import * as HypothesisSupport from './supportHypothesis';

export default async function setupIntegrations(pdfDocument, pdfViewer) {
  const hypothesisContract = await HypothesisSupport.createContract(pdfDocument, pdfViewer);

  // mixin agreed contracts to the globally exposed interface
  window.PDFViewerApplication = { ...hypothesisContract };

  HypothesisSupport.notifyDocumentLoaded(pdfViewer);
}
